import App from "../../services/App/App.js";
import AppCatalog from "../../services/App/AppCatalog.js";
import ModelBody from "./PlosModel_Body.js";

const KeySeparator = "/";

// formula: CashBased
export default {
  getChart(transactionDetails) {
    let labelList = [], summaryObj = {};
    let result = ModelBody.createChart();

    this.getChart_populateHppAdj(labelList, summaryObj, transactionDetails);
    this.getChart_populatePos(labelList, summaryObj, transactionDetails);
    this.getChart_populateDebtPay(labelList, summaryObj, transactionDetails);
    this.getChart_populateRecPay(labelList, summaryObj, transactionDetails);
    this.getChart_populateExpense(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockOpname(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockReduction(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockTrf(labelList, summaryObj, transactionDetails);

    let valueTotal = 0;
    labelList.sort();

    for (const row of labelList) {
      valueTotal += summaryObj[row];

      result.LabelList.push(
        this.getChart_getLabel(row)
      );
      result.ValueList.push(
        App.Data.getFixedDecimal(summaryObj[row])
      );
    }

    result.ValueAvg = labelList.length === 0
      ? 0
      : App.Data.getFixedDecimal(valueTotal / labelList.length);
    result.ValueAvg = App.In.getDecimal(result.ValueAvg);

    return result;
  },
  getChart_populateHppAdj(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.HppAdjList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populatePos(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.PosList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateDebtPay(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.DebtPay.AllList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] - row.Total;
      }
      else {
        summaryObj[key] = -1 * row.Total;
        labelList.push(key);
      }
    }

    for (const row of transactionDetails.DebtPay.VoidList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateRecPay(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.RecPay.AllList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }

    for (const row of transactionDetails.RecPay.VoidList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] - row.Total;
      }
      else {
        summaryObj[key] = -1 * row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateExpense(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.ExpenseList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] - row.Total;
      }
      else {
        summaryObj[key] = -1 * row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateStockOpname(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.StockOpnameList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateStockReduction(labelList, summaryObj, transactionDetails) {
    let key;
    for (const row of transactionDetails.StockReductionList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] - row.Total;
      }
      else {
        summaryObj[key] = -1 * row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_populateStockTrf(labelList, summaryObj, transactionDetails) {
    if (!Object.prototype.hasOwnProperty.call(transactionDetails, "StockTrf")) {
      return;
    }

    let key;
    for (const row of transactionDetails.StockTrf.AddList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] + row.Total;
      }
      else {
        summaryObj[key] = row.Total;
        labelList.push(key);
      }
    }

    for (const row of transactionDetails.StockTrf.SubList) {
      key = this.getChart_getKey(row.Date);

      if (labelList.includes(key)) {
        summaryObj[key] = summaryObj[key] - row.Total;
      }
      else {
        summaryObj[key] = -1 * row.Total;
        labelList.push(key);
      }
    }
  },
  getChart_getKey(dateString) {
    return dateString.substring(0, 4) + KeySeparator + dateString.substring(5, 7);
  },
  getChart_getLabel(key) {
    const keyList = key.split(KeySeparator);
    return AppCatalog.MonthNames[parseInt(keyList[1]) - 1] + " " + keyList[0];
  }
}